import React from 'react'
import { connect } from 'react-redux';
import styles from './Admissions.module.css'
import { PatientHomeAdmission } from 'PatientCareCenter/Home/Admissions'
import { ScrollDiv } from '_components';

class PatientHomeAdmissions extends React.Component {

    render() {
        if (this.props.admissions && Object.keys(this.props.admissions).length > 0) {
            return (

                <ScrollDiv divId={this.props.ptno+'_PCC_HOME_ADMISSIONS'} className={styles.admission_wrapper}>
                    {Object.keys(this.props.admissions)
                        .sort((a, b) => {
                            if (this.props.admissions[a].dischargeDate &&
                                this.props.admissions[b].dischargeDate &&
                                new Date(this.props.admissions[a].dischargeDate) >
                                new Date(this.props.admissions[b].dischargeDate)) {
                                return -1;
                            }
                            if (this.props.admissions[a].dischargeDate &&
                                this.props.admissions[b].dischargeDate &&
                                new Date(this.props.admissions[a].dischargeDate).getTime() ===
                                new Date(this.props.admissions[b].dischargeDate).getTime()) {
                                return new Date(this.props.admissions[a].startDate) > new Date(this.props.admissions[b].startDate) ? -1 : 1;
                            }
                            else if (this.props.admissions[b].dischargeDate &&
                                !this.props.admissions[a].dischargeDate) {
                                return -1;
                            }
                            else if (!this.props.admissions[a].dischargeDate &&
                                !this.props.admissions[b].dischargeDate &&
                                new Date(this.props.admissions[a].startDate).getTime() >
                                new Date(this.props.admissions[b].startDate).getTime()) {
                                return -1;
                            }
                            else {
                                return 1;
                            }
                        })
                        .map(id => {
                            const result = this.props.admissions[id];
                            return (
                                <PatientHomeAdmission key={result.id} id={result.id}/>
                            )
                        })
                    }

                </ScrollDiv>
            );
        } else {
            return (<i>No Admissions Found</i>);

        }
    }
}

function mapStateToProps(state) {
    return {
        ptno: state.ui.patients.selectedPtno,
        admissions: Object.keys(state.entities.admissions)
            .filter(key => { return state.entities.admissions[key].ptno === state.ui.patients.selectedPtno })
            .map(key => state.entities.admissions[key])
    };
}

const connectedPatientHomeAdmissions = connect(mapStateToProps)(PatientHomeAdmissions);
export { connectedPatientHomeAdmissions as PatientHomeAdmissions };